export default __webpack_public_path__ + "static/media/AuthScreenShot.d346644b.png";